import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActiveEmployeeRegistrationViewModel, EmployeeRole } from 'chronos-core-client';
import { ListValue } from 'chronos-shared';
import { notificationTopic } from '@app/shared/utils';

type EventType = {
  originalEvent: PointerEvent;
  value: EmployeeRole;
};

@Component({
  selector: 'app-loggedin-employee-table',
  templateUrl: './loggedin-employee-table.component.html',
  styleUrls: ['./loggedin-employee-table.component.scss']
})
export class LoggedinEmployeeTableComponent {
  constructor(private translateService: TranslateService) {}

  @Input() public loggedInData: ActiveEmployeeRegistrationViewModel[];
  @Output() public loggedInEmployeeBlur = new EventEmitter<ActiveEmployeeRegistrationViewModel>();
  @Output() public logOut = new EventEmitter<ActiveEmployeeRegistrationViewModel>();

  public readonly LOADING_TOPIC_LOGOUT_ = notificationTopic.employeeLogOut;
  private lastUpdateNote: string;

  public roles: ListValue[] = [
    { label: this.translateService.instant('EMPLOYEE_ROLE.OPERATOR'), value: EmployeeRole.Operator },
    { label: this.translateService.instant('EMPLOYEE_ROLE.HELPER'), value: EmployeeRole.Helper }
  ];

  public onLoggedInEmployeeBlur(note: string, activeEmployee: ActiveEmployeeRegistrationViewModel) {
    if (this.lastUpdateNote === note) return;

    this.lastUpdateNote = note;
    this.loggedInEmployeeBlur.emit(this.setEmployeeDetails(activeEmployee, null, note));
  }

  public onLogOutClick(activeEmployee: ActiveEmployeeRegistrationViewModel) {
    this.logOut.emit(activeEmployee);
  }

  public onRoleChange(newRole: EventType, activeEmployee: ActiveEmployeeRegistrationViewModel) {
    this.loggedInEmployeeBlur.emit(this.setEmployeeDetails(activeEmployee, newRole.value, null));
  }

  private setEmployeeDetails(
    activeEmployee: ActiveEmployeeRegistrationViewModel,
    newRole?: EmployeeRole,
    note?: string
  ): ActiveEmployeeRegistrationViewModel {
    const emp = {
      id: activeEmployee.id,
      employeeId: activeEmployee.employeeId,
      externalEmployeeId: activeEmployee.externalEmployeeId,
      loginTime: activeEmployee.loginTime,
      name: activeEmployee.name,
      note: note ?? activeEmployee.note,
      role: newRole ?? activeEmployee.role,
      registrationPurpose: activeEmployee.registrationPurpose
    };
    return emp;
  }
}
